export const TEXT_BASED_CHANNELS = [
    'widgetchat',
    'messenger',
    'contactform',
    'email',
    'facebookmessenger',
    'whatsapp',
    'sms',
    'twitter',
    'telegram',
];
export const PHONE_BASED_CHANNELS = [
    'pstnphone',
    'pstn_phone',
    'voicemail',
    'callback',
];
